'use strict';

const defaultType = 'BO_SB';

const OPTION_TYPE = {
    BO_SB: {
        code: 'BO_SB',
        name: 'small_bag',
    },
    BO_PB: {
        code: 'BO_PB',
        name: 'cabin_bag',
    },
    BO_HB: {
        code: 'BO_HB',
        name: 'hand_bag',
    },
};

module.exports = Odigeo.Model.extend({
    getFlightDetails: function() {
        return this.get('flightDetailsDTO');
    },
    getTripType: function() {
        return this.get('tripType');
    },
    getOptions: function() {
        return Odigeo.parseOptions(this.widget.options);
    },
    getNumTravellers: function() {
        return Odigeo._.get(this.getOptions(), 'numTravellers');
    },
    getProduct: function() {
        return Odigeo._.get(this.getOptions(), 'product');
    },
    storeBoardingOptions: function(data) {
        this.set(data);
        this.load();
    },
    getTranslations: function() {
        return Odigeo._.get(this, ['widget', 'view', 'keys']);
    },
    getTranslation: function(key) {
        const isValidOptionType = Object.keys(OPTION_TYPE).includes(key.toUpperCase());
        if (Odigeo.AB.isTravelFusionCabinBagsDesktop && isValidOptionType) {
            const optionCode = key.toUpperCase();
            const carrierProperties = Odigeo.CONFIG.cabinBagsCarrierProperties[this.getCarrier()] || {};
            const isCabinBagOption = optionCode === OPTION_TYPE.BO_PB.code;

            const keyName = `cabinbags_option_${OPTION_TYPE[optionCode].name}_aside`;
            const keyValue = Odigeo._.get(this.getTranslations(), keyName);
            if (isCabinBagOption) {
                const mainKey = Odigeo.Utils.replaceCmsKeyArgs(keyValue, carrierProperties.cabin_bag_weight);
                if (carrierProperties.priority_boarding_included) {
                    const plusPriorityKey = Odigeo._.get(this.getTranslations(), 'cabinbags_plus_priority_boarding');
                    return `${mainKey} ${plusPriorityKey}`;
                } else {
                    return mainKey;
                }
            } else {
                return keyValue;
            }
        } else {
            return Odigeo._.get(this.getTranslations(), [this.getCarrierKey(), key].join('_'));
        }
    },
    getSelectedType: function() {
        return this.get('selectedType');
    },
    isDefaultType: function() {
        return this.getSelectedType() === defaultType;
    },
    getSelectedTypeTranslation: function() {
        return this.getTranslation(this.getSelectedType().toLowerCase());
    },
    getData: function() {
        const hasStops = this.hasStops();

        return Odigeo._.extend(this.toJSON(), {
            hasStops: hasStops,
            baggageInfo: this.getBaggageInfo(hasStops),
        });
    },
    load: function() {
        if (!Odigeo._.isEmpty(this.getFlightDetails())) {
            this.widget.view.show();
        }
    },
    getSegments: function() {
        return Odigeo._.get(this.getFlightDetails(), 'segments', []);
    },
    getSections: function() {
        return Odigeo._.get(this.getFlightDetails(), 'allSections', []);
    },
    hasStops: function() {
        return !Odigeo._.isUndefined(Odigeo._.find(this.getSegments(), function(segment) {
            return segment.stops > 0;
        }));
    },
    getBaggageInfo: function(hasStops) {
        return hasStops ? this.getSectionBaggageInfo() : this.getSegmentBaggageInfo();
    },
    getSectionBaggageInfo: function() {
        const carrierList = this.getCarrierList();
        const boardingOptionsText = this.getSelectedTypeTranslation();
        const numTravellers = this.getNumTravellersTimes();
        return Odigeo._.flatten(
            Odigeo._.map(this.getSegments(),
                (segment) => Odigeo._.map(segment.sections,
                    (section) => {
                        return {
                            key: this.getFlightIdentifier(section),
                            text: Odigeo._.includes(carrierList, Odigeo._.get(section, 'carrier.code', ''))
                                ? numTravellers + boardingOptionsText
                                : this.getSegmentContentKey(segment),
                        };
                    }
                )
            )
        );
    },
    getNumTravellersTimes: function() {
        return this.isDefaultType() ? '' : this.getNumTravellers() + ' x ';
    },
    getFlightIdentifier: function(section) {
        return [
            Odigeo._.get(section, 'departureLocation.iata', ''),
            Odigeo._.get(section, 'arrivalLocation.iata', ''),
        ].join(' - ');
    },
    getSegmentBaggageInfo: function() {
        const carrierList = this.getCarrierList();
        const boardingOptionsText = this.getSelectedTypeTranslation();
        const numTravellers = this.getNumTravellersTimes();
        return Odigeo._.map(this.getSegments(), function(segment) {
            return Odigeo._.includes(carrierList, Odigeo._.get(segment, 'carrier.code', ''))
                ? numTravellers + boardingOptionsText
                : this.getSegmentContentKey(segment);
        }, this);
    },
    getSegmentContentKey: function(segment) {
        const key = Odigeo._.get(segment, 'baggage.includedType', '');
        return this.getContentKey(key) || this.getContentKey(defaultType);
    },
    getContentKey: function(key) {
        return Odigeo._.get(this, ['widget', 'view', 'keys', key.toLowerCase()]);
    },
    getCarrierKey: function() {
        return this.getCarrier().toLowerCase().replace('.', '_');
    },
    getCarrier: function() {
        return this.get('carrier') || '';
    },
    getCarrierList: function() {
        return this.get('carrierList') || [];
    },
});
